import { useTranslation } from 'react-i18next';
import { Button } from '@semsis/ui/Button';
import { Alert } from '@semsis/ui/Alert';
import styles from './CredentialError.module.css';

interface CredentialErrorProps {
  onRetry: () => void;
}

export function CredentialError({ onRetry }: CredentialErrorProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Alert variant="error">
        {t('credential.error.message')}
      </Alert>
      <Button onClick={onRetry}>
        {t('credential.error.retry')}
      </Button>
    </div>
  );
}
